export enum AssignableState {
    DELETED = 0,
    JOINED = 1,
    INVITED = 2,
    PASSIVE = 3
}